import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-474f6ede"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ue-transfer-box"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "ue-idle-agent-box"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "wtue wtue-zhuanjie"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "ue-outline-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: _ctx.activeName,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.activeName = $event),
    onTabClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "其他员工",
      name: "agent"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        class: "ue-transfer-select",
        "popper-class": "ue-transfer-select",
        placeholder: '请输入座席工号、姓名、技能组名称查询',
        onVisibleChange: _ctx.visibleChange,
        "filter-method": _ctx.dataFilter,
        filterable: "",
        modelValue: _ctx.form.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.form.id = $event),
        ref: "selectTree"
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_option, {
          key: _ctx.form.id,
          value: _ctx.form.id,
          label: _ctx.form.label,
          hidden: ""
        }, null, 8, ["value", "label"])), _createVNode(_component_el_tree, {
          data: _ctx.agentOptions,
          props: _ctx.props,
          "node-key": "id",
          accordion: "",
          ref: "tree",
          "highlight-current": "",
          "filter-node-method": _ctx.filterNode
        }, {
          default: _withCtx(({
            data
          }) => [data.freeNumber >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(data.label), 1), _createElementVNode("span", null, "（" + _toDisplayString(data.freeNumber) + "）", 1)])) : _createCommentVNode("", true), data.agentNumber ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(data.label) + " (" + _toDisplayString(data.agentNumber) + ") ", 1), _createElementVNode("span", {
            onClick: $event => _ctx.transferAction(data.agentNumber, 'agent')
          }, _hoisted_6, 8, _hoisted_4)])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data", "props", "filter-node-method"])]),
        _: 1
      }, 8, ["onVisibleChange", "filter-method", "modelValue"])]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "外线电话",
      name: "outline"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
        modelValue: _ctx.outlineNumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.outlineNumber = $event),
        size: "mini",
        clearable: "",
        placeholder: "请输入手机或完整的区号电话号码",
        style: {
          "width": "244px"
        }
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        class: "ue-action-btn",
        disabled: !_ctx.outlineNumber,
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.transferAction(_ctx.outlineNumber, 'outline', _ctx.outlineNumber), ["stop"]))
      }, {
        default: _withCtx(() => [_createTextVNode("转移")]),
        _: 1
      }, 8, ["disabled"])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue", "onTabClick"])]);
}